import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import useFormStore from '../../store/useFormStore';
import FormStepLayout from '../../templates/FormStepLayout/FormStepLayout';
import RightSidebar from '../../components/sidebars/RightSidebar';
import EstimateTypeSelection from '../../components/EstimateTypeSelection';
import ShortLeadFormFields from '../../components/shortLeadFrom/ShortLeadFormFields';
import ServiceSelectionGrid from '../../components/ServiceSelectionGrid';

export default function SelectService({ franchise, onNext, onBack, cartRef, services }) {
  const selectedServices = useFormStore((state) => state.selectedServices) || [];
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const selectedEstimateType = useFormStore((state) => state.selectedEstimateType);
  const clearAllAppointments = useFormStore((state) => state.clearAllAppointments);
  const shortLeadFormPreferredDate = useFormStore((state) => state.shortLeadFormPreferredDate);
  const setEstimateType = useFormStore((state) => state.setEstimateType);
  const estimateTypeManuallySelected = useFormStore((state) => state.estimateTypeManuallySelected);

  // Clear all scheduled appointments when landing on this page
  useEffect(() => {
    clearAllAppointments();
  }, []);

  // Auto-select the first form type from franchise if available
  useEffect(() => {
    const formTypes = currentFranchise?.form_type;
    if (formTypes && !estimateTypeManuallySelected) {
      const formTypeKeys = Object.keys(formTypes);
      const firstFormType = formTypeKeys[0];

      // Always use the first form type from the franchise unless user manually selected
      if (firstFormType && selectedEstimateType !== firstFormType) {
        setEstimateType(firstFormType, false);
      }
    }
  }, [currentFranchise?.form_type, estimateTypeManuallySelected]);

  // Only show selection if there are multiple form types to choose from
  const formTypeCount = currentFranchise?.form_type ? Object.keys(currentFranchise.form_type).length : 0;
  const requiresEstimateType = formTypeCount > 1;

  // Check if we should show the short lead form
  const showShortLeadForm = selectedEstimateType === 'on_site_estimate_short';

  // Determine if next button should be disabled
  const getNextDisabled = () => {
    // Short lead form validation
    if (showShortLeadForm) {
      return !shortLeadFormPreferredDate || selectedServices.length === 0;
    }
    // Normal flow validation
    return selectedServices.length === 0 || (requiresEstimateType && !selectedEstimateType);
  };

  // Determine next button text and screen
  const getNextText = () => {
    return showShortLeadForm ? 'Next: Your Information' : 'Next: Service Details';
  };

  return (
    <FormStepLayout
      onNext={onNext}
      onBack={onBack}
      nextText={getNextText()}
      nextDisabled={getNextDisabled()}
      showBackButton={false}
      leftSidebar={true}
      rightSidebar={
        <RightSidebar
          showCartRequirements={false}
          showAppointmentDetails={false}
          showCart={false}
          showFranchiseDisclaimer={false}
          showPortableInfo={false}
        />
      }
      title='What can we help you with'
    >
      {/* Estimate Type Selection - Show if franchise requires it */}
      {requiresEstimateType && <EstimateTypeSelection />}

      {showShortLeadForm ? (
        <ShortLeadFormFields />
      ) : (
        <ServiceSelectionGrid services={services} />
      )}

    </FormStepLayout>
  );
}
